import { useState, useEffect } from "react";
import "./About.css";

function About() {
  // create state to hold about data
  const [about, setAbout] = useState(null);

  // create function to make api call
  const getAboutData = async () => {

		// make api call and get response
    const response = await fetch("./about.json");

		// turn response into javascript object
    const data = await response.json();

		// set the about state to the data
    setAbout(data);
  };

  // make an initial call for the data inside a useEffect, so it only happens once on component load
  useEffect(() => { getAboutData() } , []);

  // define a function that will return the JSX needed once we get the data
  const loaded = () => (
    <div className="about-page">
      <img className="profile" src={about.headshot} alt="Profile Picture" />
      <h2>{about.name}</h2>
      <p><a href={`mailto:${about.email}`}>{about.email}</a></p>
      <p>
      <a href={about.linkedin}>
        <i className="fa fa-linkedin"></i>
        LinkedIn
      </a>
    </p>
    <p>
      <a href={about.github}>
        <i className="fab fa-github"></i>
        Git Hub
      </a>
    </p>
      <p className="paragraph p-animation">{about.bio}</p>
    </div>
  );

  // if data arrives return the result of loaded, if not, an h1 that says loading
  return about ? loaded() : <h1>Loading...</h1>;
}

export default About;


  